"use client";

import { LayoutDashboard, Dumbbell, Ruler, PackageCheck } from "lucide-react";
import { useTranslations } from "next-intl";

const ICONS = [
  { icon: <LayoutDashboard size={20} />, iconBg: "bg-yellow-100", iconColor: "text-yellow-600" },
  { icon: <Dumbbell size={20} />, iconBg: "bg-blue-100", iconColor: "text-blue-500" },
  { icon: <Ruler size={20} />, iconBg: "bg-green-100", iconColor: "text-green-600" },
  { icon: <PackageCheck size={20} />, iconBg: "bg-purple-100", iconColor: "text-purple-600" },
];

type Feature = { title: string; text: string };

export default function EquipmentOfferHeroSection() {
  const t = useTranslations("EquipmentOfferHero");
  const features = (t.raw("features") as Feature[]).map((f, i) => ({ ...f, ...ICONS[i] }));

  return (
    <section className="py-14 sm:py-16">
      {/* Heading */}
      <h1 className="mb-10 text-4xl font-bold tracking-tight text-[#18181b] sm:text-5xl">
        {t("heading")}
      </h1>

      {/* Feature cards */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {features.map((f) => (
          <div
            key={f.title}
            className="flex flex-col gap-5 rounded-2xl border border-[#E4E4E7] bg-[#F9FAFB] p-5"
          >
            {/* Icon block */}
            <div
              className={`flex h-10 w-10 items-center justify-center rounded-xl ${f.iconBg} ${f.iconColor}`}
            >
              {f.icon}
            </div>

            {/* Text */}
            <div className="flex flex-col gap-2">
              <h2 className="text-base font-semibold leading-snug text-[#18181b]">
                {f.title}
              </h2>
              <p className="text-sm leading-relaxed text-[#52525b]">{f.text}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Quote banner */}
      <div className="mt-8 rounded-2xl bg-[#F4F4F5] px-8 py-10 text-center">
        <p className="text-2xl italic text-[#18181b] sm:text-3xl">
          {t("quote")}
        </p>
      </div>
    </section>
  );
}
